import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=53a156dc&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53a156dc')) {
      api.createRecord('53a156dc', component.options)
    } else {
      api.reload('53a156dc', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=53a156dc&", function () {
      api.rerender('53a156dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-40bbnnjNxCQQ2/JS/comp/childrenage.vue"
export default component.exports